import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'
import * as echarts from 'echarts'
import api from './api'
import { installI18n } from '@/utils/i18n'
import SmartPagination from '@/components/SmartPagination.vue'

Vue.use(ElementUI)
installI18n(Vue)
// 全局注册智能分页：PC 端同原 el-pagination，手机端自动切换为 上一页/下一页+页码跳转+总条数/总页数（各页无需单独 import）
Vue.component('SmartPagination', SmartPagination)
Vue.prototype.$echarts = echarts
Vue.prototype.$api = api

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
